import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserState } from '@gea/digital-ui-lib';
import { Store } from '@ngxs/store';
import { filter, map, switchMap, take } from 'rxjs';
import { BrsPermission } from './permission.model';
import { PermissionService } from './permission.service';

/**
 * Allows the route only if the user has the permission in `route.data.permission`,
 * otherwise redirects to the dashboard. A route without `data.permission` is denied.
 * Waits for the login to finish so the permission token can be validated against the MSAL session.
 */
export const permissionGuard: CanActivateFn = (route) => {
  const permissionService = inject(PermissionService);
  const router = inject(Router);
  const permission = route.data['permission'] as BrsPermission | undefined;

  return inject(Store)
    .select(UserState.token)
    .pipe(
      filter(Boolean),
      take(1),
      switchMap(() => permissionService.ensureLoaded()),
      map(() => (permission && permissionService.hasPermission(permission) ? true : router.createUrlTree(['/home'])))
    );
};
